import * as React from "react";
import { createUseStyles } from "react-jss";
import Toolbar from "@warda/library-ui/core/Toolbar";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import Divider from "@warda/library-ui/core/Divider";
import SelectActions from "./SelectActions";
import BtnNavigateBack from "./Buttons/BtnNavigateBack";
import BtnBreadcrumb from "./Buttons/BtnBreadcrumb";
import BtnSort from "./Buttons/BtnSort";
import BtnView from "./Buttons/BtnView";
import BtnSearch from "./Buttons/BtnSearch";
import BtnCleanFilters from "./Buttons/BtnCleanFilters";
import { areFiltersUseful } from "../PanelFilters";
import FilePath from "./FilePath";
import FilterFileNameMobile from "./Filters/FilterFileNameMobile";
import { ViewMode } from "./constants";
import FilterFileType from "./Filters/FilterFileType";
import { FILENAME_FILTER_INDEX, TYPES_FILTER_INDEX } from "./Filters/constants";
const useStyles = createUseStyles({
    toolbar: {
        height: "auto",
    },
});
const ToolbarActions = ({ pagePrntId, files, filesSlcId, folderPath, sortKey, sortOrd, viewMode, viewType, filters, }) => {
    const classes = useStyles({});
    const isFiltered = areFiltersUseful(filters);
    const isSelected = filesSlcId.length > 0;
    if (isMobile()) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Toolbar, { className: classes.toolbar }, isSelected ? (React.createElement(React.Fragment, null,
                React.createElement(SelectActions, { filesSlcId: filesSlcId }),
                isMobile() || !isFiltered || filesSlcId.length !== 1 ? null : (React.createElement(FilePath, { pagePrntId: pagePrntId, file: files.find((f) => f.id === filesSlcId[0]) })))) : (React.createElement(React.Fragment, null,
                folderPath.length === 0 || viewMode === ViewMode.SEARCH ? (React.createElement(FilterFileNameMobile, { value: filters[FILENAME_FILTER_INDEX].value, showClose: viewMode === ViewMode.SEARCH })) : (React.createElement(React.Fragment, null,
                    React.createElement(BtnNavigateBack, { folderPath: folderPath }),
                    React.createElement(BtnBreadcrumb, { pagePrntId: pagePrntId, folderPath: folderPath }),
                    React.createElement("div", { style: { flex: 1 } }))),
                React.createElement(BtnSearch, { viewMode: viewMode })))),
            React.createElement(Divider, null),
            React.createElement(Toolbar, null, viewMode === ViewMode.SEARCH ? (React.createElement(React.Fragment, null,
                React.createElement(FilterFileType, { value: filters[TYPES_FILTER_INDEX].value, options: filters[TYPES_FILTER_INDEX].options }),
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(BtnCleanFilters, { filters: filters }))) : (React.createElement(React.Fragment, null,
                React.createElement(BtnSort, { sortKey: sortKey, sortOrd: sortOrd }),
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(BtnView, { view: viewType }))))));
    }
    return (React.createElement(Toolbar, null,
        isSelected ? (React.createElement(React.Fragment, null,
            React.createElement(SelectActions, { filesSlcId: filesSlcId }),
            !isFiltered || filesSlcId.length !== 1 ? null : (React.createElement(FilePath, { pagePrntId: pagePrntId, file: files.find((f) => f.id === filesSlcId[0]) })))) : (React.createElement(React.Fragment, null,
            React.createElement(BtnNavigateBack, { folderPath: folderPath }),
            React.createElement(BtnBreadcrumb, { pagePrntId: pagePrntId, folderPath: folderPath }))),
        React.createElement("div", { style: { flex: 1 } }),
        React.createElement(BtnSort, { sortKey: sortKey, sortOrd: sortOrd }),
        React.createElement(BtnView, { view: viewType })));
};
export default ToolbarActions;
